import React from 'react'
import {createPortal} from 'react-dom'

import {$isAutoLinkNode, $isLinkNode} from '@lexical/link'
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext'
import {$findMatchingParent, mergeRegister} from '@lexical/utils'
import {
    $getSelection,
    $isRangeSelection,
} from 'lexical'
import {useCallback, useEffect, useState} from 'react'
import {getSelectedNode} from '../../utils/getSelectedNode'
import FloatingLinkEditor from "./link-editor"

export default function FloatingLinkEditorPlugin(): JSX.Element | null {
    const [editor] = useLexicalComposerContext()

    const [isLink, setIsLink]   = useState(false)
    const [linkUrl, setLinkUrl] = useState('')

    const updateLinkEditor = useCallback(() => {
        const selection = $getSelection()
        if ($isRangeSelection(selection)) {
            const node = getSelectedNode(selection)
            const parent = node.getParent()
            if ($isLinkNode(parent)) {
                setLinkUrl(parent.getURL())
            } else if ($isLinkNode(node)) {
                setLinkUrl(node.getURL())
            } else {
                setLinkUrl('')
            }
        }

        return true
    }, [editor])

    const updateToolbar = useCallback(() => {
        const selection = $getSelection()
        if ($isRangeSelection(selection)) {
            const node              = getSelectedNode(selection)
            const linkParent        = $findMatchingParent(node, $isLinkNode)
            const autoLinkParent    = $findMatchingParent(node, $isAutoLinkNode)

            // We don't want this menu to open for auto links.
            if (linkParent != null && autoLinkParent == null) {
                setIsLink(true)
            } else {
                setIsLink(false)
            }
        }
    }, [])

    useEffect(() => {
        return mergeRegister(
            editor.registerUpdateListener(({editorState}) => {
                editorState.read(() => {
                    updateLinkEditor()
                    updateToolbar()
                })
            }),
        )
    }, [editor, updateToolbar])

    return createPortal(
        <FloatingLinkEditor editor  = {editor}
                            isLink  = {isLink}
                            linkUrl = {linkUrl}/>,
        document.body,
    )
}
